/**
 * The Uncut Gems wordmark, set as the website sets it (uncutgems.com): Anton, uppercase, upright, the two words
 * solid, "Uncut" in paper white and "Gems" in the teal of the gem. One component for every place the portal
 * shows it; ErrorBoundary keeps its own inline copy, because it must draw when nothing else can.
 *
 * `size` is a font size: a number of pixels, or any CSS length (the sign-in pages pass a clamp()).
 * `icon` puts the gem mark to its left, 10px off, as the website's nav does (files sized for the default 24px).
 *
 * The two inks also carry classes (index.css, "The wordmark"): the light theme repaints headings and everything in
 * the dark sidebar with !important, which beats an inline colour. There "Gems" stays teal, and "Uncut" takes the
 * light theme's heading ink on a light surface (the phone's top bar) and stays paper on the dark sidebar.
 */
export function Wordmark({ size = 20, icon = false, iconSize = 24, className = '' }) {
  const mark = (
    <span style={{ fontFamily: 'Anton, Impact, sans-serif', textTransform: 'uppercase', letterSpacing: '-0.02em',
                   lineHeight: 1, fontSize: size, fontWeight: 400, fontStyle: 'normal', whiteSpace: 'nowrap' }}>
      <span className="ug-wordmark-uncut" style={{ color: '#f4f4f5' }}>Uncut</span>
      <span className="ug-wordmark-gems" style={{ color: '#2bb3a8' }}>Gems</span>
    </span>
  );
  if (!icon) return <span className={className}>{mark}</span>;
  return (
    <span className={`inline-flex items-center ${className}`} style={{ gap: 10 }}>
      <img src="/gem-mark-48.png" srcSet="/gem-mark-48.png 2x, /gem-mark-72.png 3x" alt="" style={{ width: iconSize, height: iconSize }} />
      {mark}
    </span>
  );
}
